module.exports = __webpack_public_path__ + "img/1.2921bdf3.png";